<template>
<div>

  <div class="columns">
    <div class="column">
      <select-input
        :items="availableScrapers"
        v-model="scraper.type"
        value-key="handler"
        label-key="handler">
        Scraper Type
      </select-input>
    </div>
  </div>

  <div v-if="scraper.type && scraper.type !== 'Snitches\\Scrapers\\SourceCodeLookup'">
    <div class="columns">
      <div class="column">
        <text-area 
          required
          v-model="scraper.scraper_payload"
          v-if="activeScraper && activeScraper.requires_input">
          Payload
        </text-area>
        <submit-button :working="storing" @submit="store">Store</submit-button>
      </div>
    </div>
  </div>

  <!-- <scraper-source-target-builder 
    v-if="scraper.type === 'Snitches\\Scrapers\\SourceCodeLookup'"
    :primary-scraper="primaryScraper"
    :primary-scraper-payload="attributeType.scraper_payload"
    :scrapable="attributeType"/> -->
</div>  
</template>
<script>
import { mapGetters } from 'vuex'
import { get } from '@/api/request'
import { find, differenceBy } from 'lodash'

export default {

  data: () => ({
    storing: false,
    scrapers: [],
    scraper: {
      type: '',
      scraper_payload: ''
    }
  }),

  beforeCreate() {
    get('api/super/secondary-scraper-types', ({data}) => this.scrapers = data)
  },

  methods: {
    store() {
      this.storing = true
      this.$store.dispatch('attributeType/storeSecondaryScraper', {
        handler: this.scraper.type,
        type: 'attribute',
        scraper_payload: this.scraper.scraper_payload,
        invokable_params: this.activeScraper.invokable_params,
        return_type: this.activeScraper.return_type,
      }).then(() => {
        this.$toast.success('Scraper Stored')
        this.$router.back()
      }).catch(error => this.storing = false)
    }
  },
  
  computed: {
    ...mapGetters('attributeType', [
      'attributeType'
    ]),
    primaryScraper() {
      return this.attributeType.scraper
    },
    attributeSecondaryScrapers() {
      return this.attributeType.secondary_scrapers
    },
    availableScrapers() {
      let scrapers = this.scrapers.filter(scraper => {
        if(this.attributeType.type === 'source') {
          return scraper.type === 'source'
        } else {
          return scraper.type !== 'source'
        }
      })

      if(this.attributeType.type === 'source') {
        return scrapers
      }
      return differenceBy(scrapers, this.attributeType.secondary_scrapers, 'handler')
    },
    activeScraper() {
      return find(this.scrapers, scraper => scraper.handler === this.scraper.type)
    },
  }

}
</script>